module.exports = __webpack_public_path__ + "static/media/multi-image-3.61a58174.png";